import { IsArray, IsNotEmpty, Matches, Validate, ValidateNested } from 'class-validator';
import { Type } from 'class-transformer';
import { TimeRangesAreValid } from 'src/actions/endpoints/timeRangeValidator';

export const TIME_PATTERN = /^(0[0-9]|1[0-9]|2[0-4]):[0-5][0-9]$/;

class OfficeHours {
  @IsNotEmpty({ message: 'Select a timezone' })
  timezone: string;

  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => ScheduleBlock)
  monday: ScheduleBlock[];

  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => ScheduleBlock)
  tuesday: ScheduleBlock[];

  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => ScheduleBlock)
  wednesday: ScheduleBlock[];

  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => ScheduleBlock)
  thursday: ScheduleBlock[];

  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => ScheduleBlock)
  friday: ScheduleBlock[];

  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => ScheduleBlock)
  saturday: ScheduleBlock[];

  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => ScheduleBlock)
  sunday: ScheduleBlock[];
}

export class ScheduleBlock {
  @Matches(TIME_PATTERN, { message: 'Invalid time format' })
  @IsNotEmpty({ message: 'Start time needs to be filled' })
  start: string;

  @Matches(TIME_PATTERN, { message: 'Invalid time format' })
  @Validate(TimeRangesAreValid)
  @IsNotEmpty({ message: 'End time needs to be filled' })
  stop: string;
}

export default OfficeHours;
